// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { fibo as _fibo } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the fibo chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 12306
 * Chain Name: Fibo Chain
 * Default Block Explorer: https://scan.fibochain.org
 * Default RPC URL: https://network.hzroc.art
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { fibo } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: fibo,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const fibo = createCommon({
	..._fibo,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
